import { Component } from '@angular/core';
import { StreamService, UserService } from '../services';
import { first } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    template: `
        <router-outlet></router-outlet>
    `
})
export class BrowseNewTopicsPane {
}
